import usePeriodContext from 'app/KinerjaShared/hooks/usePeriodContext'
import { getPelaksanaanDate } from 'app/KinerjaShared/utils/pelaksanaan'
import { isDateStarted } from 'app/KinerjaShared/utils/pelaksanaan'

export function usePelaksanaanDate() {
  const { periods, period: selectedPeriod } = usePeriodContext()

  const isResolved = Array.isArray(periods) && periods.length > 0
  const periodeKinerja = selectedPeriod.periodeKinerja

  const isStarted = isResolved && isDateStarted(periodeKinerja)
  const date = getPelaksanaanDate(periodeKinerja)

  return {
    isStarted,
    isResolved,
    date,
  }
}
